export const CUSTOM_NGX_DATE_FORMATS = {
  parse: {
    dateInput: 'yyyy-MM-DD HH:mm'
  },
  display: {
    dateInput: 'yyyy-MM-DD HH:mm',
    dateA11yLabel: 'yyyy-MM-DD',
    monthYearLabel: 'MMM yyyy',
    monthYearA11yLabel: 'MMM yyyy'
  }
};

export const CUSTOM_NATIVE_DATE_FORMATS = {
  parse: {
    dateInput: 'YYYY-MM-DD'
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};
